<template>
  <page layoutClass="projects-index" :err="err">
    <!-- Header -->
    <b-row class="my-3">
      <b-col cols="12" sm="7">
        <h2 class="m-0">Projects</h2>
      </b-col>
      <b-col cols="12" sm="5" class="d-flex flex-row justify-content-end align-items-center" v-if="isRecruiter && showAddProjectsButton">
        <b-button size="md" variant="outline-primary" :to="{ name: 'ProjectNew' }">
          <font-awesome-icon icon="plus"/>
          <span class="d-none d-sm-inline-block">Add New</span>
        </b-button>
      </b-col>
    </b-row>

    <projects-filter
      v-if="isRecruiter"
      layout="page"
      :loading="$apollo.loading || !projects"
      :projects="projects"
    />

    <internal-jobs-list
      v-else
      layout="block"
      :loading="$apollo.loading || !jobs"
      :whereCustomFields="jobs ? jobs.jobAggs : null"
      :where="filterJobsWhere"
      @whereUpdated="filterJobsWhereUpdated"
      :results="jobs ? jobs.jobConnections : null"
      @pageUpdated="filterJobsPageUpdated"
      :order="filterJobsOrder"
      @orderUpdated="filterJobsOrderUpdated"
      :isProjectDisplay="true"
    />
  </page>
</template>

<script>
import base64 from 'base-64';
import ms from 'ms';
import enumsMixin from '@src/mixins/enums';
import ProjectsFilter from '@/components/projects/FilterContainer';
import InternalJobsList from '@/components/projects/InternalJobsListContainer';
import Page from '@/components/Page';
import InternalProjectsIndexQuery from '@/graphql/queries/InternalProjectsIndex.gql';
import InternalProjectRolesIndexQuery from '@/graphql/queries/InternalProjectRolesIndex.gql';
import { mapRoot } from '@src/mixins/root';

export default {
  components: {
    Page,
    ProjectsFilter,
    InternalJobsList,
  },
  mixins: [
    enumsMixin,
  ],
  created() {
    if (this.company && this.company.sitePreferences) {
      const { company: { sitePreferences } } = this;
      this.filterJobsOrder = sitePreferences.defaultInternalJobOrderBy || this.filterJobsOrder;
      this.filterJobsOrder = this.$route.query ? (this.$route.query.order || this.filterJobsOrder) : this.filterJobsOrder;
    }

    if (this.$route && this.$route.query && this.$route.query.filter) {
      const { where, order, page, limit } = JSON.parse(base64.decode(this.$route.query.filter));
      this.$log.debug({ where, order, page, limit });

      if (typeof where === 'object') {
        this.filterJobsWhere = { ...this.filterJobsWhere, ...where };
      }
      if (typeof order === 'string') {
        this.filterJobsOrder = order;
      }
      if (typeof page === 'number') {
        this.filterJobsPage = page;
      }
      if (typeof limit === 'number') {
        this.filterJobsLimit = limit;
      }
    }
  },
  data: () => ({
    err: null,
    filterJobsWhere: {
      isInternal: true,
      NOT: {
        project: null,
      },
      project: {
        status: 'ACTIVE',
      },
      status: 'ACTIVE',
    },
    filterJobsPage: 1,
    filterJobsLimit: 20,
    filterJobsOrder: 'CREATED_DESC',
  }),
  apollo: {
    projects: {
      query: InternalProjectsIndexQuery,
      update(data) {
        if (this.isRecruiter) {
          const { company: { projects } = {} } = data;
          console.log('PROJECT CONNECTIONS: ', { projects });
          return projects;
        }
      },
      error(err) {
        this.$log.error(err);
      },
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
      deep: true,
      throttle: ms('1s'),
    },
    jobs: {
      query: InternalProjectRolesIndexQuery,
      variables() {
        const { filterJobsWhere: where, filterJobsOrder: order, filterJobsPage: page, filterJobsLimit: limit } = this;
        return { where, order, page, limit };
      },
      update(data) {
        const { company: { jobConnections, jobAggs } = {} } = data;
        return { jobConnections, jobAggs };
      },
      error(err) {
        this.$log.error(err);
      },
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
      deep: true,
      throttle: ms('1s'),
    },
  },
  metaInfo() {
    return {
      title: 'Projects',
    };
  },
  computed: {
    ...mapRoot([ 'company', 'isLoggedIn', 'isRecruiter' ]),
    showAddProjectsButton() {
      return true;
    },
  },
  methods: {
    filterJobsWhereUpdated(where) {
      if (JSON.stringify(this.filterJobsWhere) !== JSON.stringify(where)) {
        this.filterJobsWhere = where;
        this.filterJobsPage = 1;

        this.updateRouteFilter({ where });
        this.$scrollTo('body');
      }
    },
    filterJobsOrderUpdated(order) {
      this.filterJobsOrder = order;
      this.filterJobsPage = 1;

      this.updateRouteFilter({ page: undefined, order });
      this.$scrollTo('body');
    },
    filterJobsPageUpdated(page) {
      this.filterJobsPage = page;
      this.updateRouteFilter({ page });
      this.$scrollTo('body');
    },
    updateRouteFilter(values) {
      const existing = this.$route && this.$route.query ? this.$route.query.filter : null;
      this.$router.push({
        ...this.$route,
        query: {
          filter: base64.encode(JSON.stringify({
            ...(existing ? JSON.parse(base64.decode(existing)) : {}),
            ...values
          })),
        },
      });
    },
  },
};
</script>
<style lang="scss">
.page .projects-index {

  h2 {
    margin-bottom: 0.75em;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/projects/ProjectsIndex.vue